// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_m7-0";